(() => {
  if (window.natiCommerceReady) return;
  window.natiCommerceReady = true;
  const config = window.NatiCups || {};
  const labels = config.labels || {};
  const root = (config.root || '/').replace(/\/?$/, '/');
  let returnFocus = null;
  let cartBusy = false;
  const text = (name, fallback) => labels[name] || fallback;
  const status = (message) => { const node = document.getElementById('shop-status'); if (node) node.textContent = message; };
  const money = (cents, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency || config.currency || 'USD' }).format(cents / 100);
  function showError(node, message) { if (node) { node.textContent = message; node.hidden = false; } status(message); }
  function openDialog(dialog, opener) {
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    returnFocus = opener || document.activeElement;
    if (!dialog.open) dialog.showModal();
    return true;
  }
  async function refreshCart(opener, open = true) {
    const response = await fetch(root + '?section_id=cart-drawer', { headers: { Accept: 'text/html' } });
    if (!response.ok) throw new Error(text('error', 'Your cart could not be loaded. Please open the full cart.'));
    const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
    const updated = documentFragment.querySelector('.cart-drawer-content');
    const drawer = document.getElementById('cart-drawer');
    if (!updated || !drawer) throw new Error(text('error', 'Please open the full cart.'));
    drawer.replaceChildren(updated);
    document.querySelectorAll('[data-cart-count]').forEach(node => { node.textContent = updated.dataset.count || '0'; });
    if (open) openDialog(drawer, opener);
    return drawer;
  }
  function updateProduct(section, updateUrl = false) {
    const json = section.querySelector('[data-product-variants]');
    const select = section.querySelector('[data-variant-select]');
    if (!json || !select) return;
    let data;
    try { data = JSON.parse(json.textContent); } catch { return; }
    const variant = data.variants.find(item => String(item.id) === select.value);
    if (!variant) return;
    const form = section.querySelector('[data-product-form]');
    const planSelect = form.querySelector('[data-selling-plan]');
    let allocation;
    if (planSelect) {
      const available = new Set(variant.allocations.map(item => String(item.id)));
      Array.from(planSelect.options).forEach(option => { option.disabled = !!option.value && !available.has(option.value); option.hidden = option.disabled; });
      if (!planSelect.selectedOptions.length || planSelect.selectedOptions[0].disabled) {
        const choice = Array.from(planSelect.options).find(option => !option.disabled);
        planSelect.value = choice ? choice.value : '';
      }
      allocation = variant.allocations.find(item => String(item.id) === planSelect.value);
    }
    const available = variant.available && (!data.requiresSellingPlan || !!allocation);
    const price = allocation ? allocation.price : variant.price;
    const compare = allocation ? allocation.compare : variant.compare;
    section.querySelectorAll('[data-product-price]').forEach(node => { node.textContent = money(price, section.dataset.currency); });
    const compareNode = section.querySelector('[data-compare-price]');
    compareNode.hidden = !(compare > price);
    compareNode.textContent = compare ? money(compare, section.dataset.currency) : '';
    const button = form.querySelector('[data-add-button]');
    button.disabled = !available;
    form.querySelector('[data-add-label]').textContent = available ? text('add', 'Add to inventory') : text('sold_out', 'Sold out');
    const quantity = form.elements.quantity;
    quantity.min = variant.min;
    quantity.step = variant.increment;
    if (variant.max) quantity.max = variant.max; else quantity.removeAttribute('max');
    if (+quantity.value < variant.min) quantity.value = variant.min;
    if (variant.max && +quantity.value > variant.max) quantity.value = variant.max;
    const image = section.querySelector('.product-main-image');
    const imageSource = variant.image || section.dataset.defaultImage;
    if (image && imageSource) { image.src = imageSource; image.removeAttribute('srcset'); }
    if (updateUrl) { const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url); }
  }
  document.addEventListener('change', event => {
    if (event.target.matches('[data-variant-select],[data-selling-plan]')) {
      const section = event.target.closest('[data-product-section]');
      const error = section.querySelector('[data-product-error]');
      if (error) error.hidden = true;
      updateProduct(section, true);
    }
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-product-form]');
    if (!form || !window.fetch || !document.getElementById('cart-drawer')?.showModal) return;
    event.preventDefault();
    if (form.dataset.busy) return;
    const button = form.querySelector('[data-add-button]');
    const label = form.querySelector('[data-add-label]');
    const error = form.querySelector('[data-product-error]');
    error.hidden = true;
    form.dataset.busy = 'true';
    button.disabled = true;
    label.textContent = text('adding', 'Adding…');
    try {
      const payload = new FormData(form);
      const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: payload });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || text('error', 'Please try again.'));
      status(text('added', 'Added to your inventory'));
      try { await refreshCart(button); } catch {
        const cartUrl = root + 'cart';
        error.replaceChildren(document.createTextNode(text('added', 'Added to your inventory') + '. '));
        const link = document.createElement('a'); link.href = cartUrl; link.textContent = text('view_cart', 'View full cart'); error.append(link); error.hidden = false;
      }
    } catch (failure) { showError(error, failure.message || text('error', 'Please try again.')); }
    finally { delete form.dataset.busy; updateProduct(form.closest('[data-product-section]')); }
  });
  document.addEventListener('click', async event => {
    const close = event.target.closest('[data-cart-close],[data-lore-close]');
    if (close) { close.closest('dialog')?.close(); return; }
    const opener = event.target.closest('[data-cart-open]');
    if (opener && document.getElementById('cart-drawer')?.showModal && !event.ctrlKey && !event.metaKey && !event.shiftKey) {
      event.preventDefault();
      try { await refreshCart(opener); } catch { location.href = opener.href; }
      return;
    }
    const change = event.target.closest('[data-cart-change]');
    if (change) {
      if (cartBusy) return;
      cartBusy = true;
      const drawer = document.getElementById('cart-drawer');
      drawer.setAttribute('aria-busy', 'true');
      drawer.querySelectorAll('[name="checkout"]').forEach(button => { button.disabled = true; });
      const error = drawer.querySelector('[data-cart-error]');
      if (error) error.hidden = true;
      const key = change.dataset.lineKey;
      try {
        const response = await fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: Number(change.dataset.quantity) }) });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || text('error', 'Please try again.'));
        await refreshCart(null, false);
        const replacement = Array.from(drawer.querySelectorAll('[data-cart-change]')).find(node => node.dataset.lineKey === key);
        (replacement || drawer.querySelector('[data-cart-close]')).focus();
        status(text('updated', 'Cart updated'));
      } catch (failure) { showError(drawer.querySelector('[data-cart-error]'), failure.message || text('error', 'Please try again.')); }
      finally { drawer.removeAttribute('aria-busy'); drawer.querySelectorAll('[name="checkout"]').forEach(button => { button.disabled = false; }); cartBusy = false; }
      return;
    }
    const lore = event.target.closest('[data-lore]');
    if (lore) {
      const dialog = document.getElementById('lore-dialog');
      if (!dialog) return;
      const title = dialog.querySelector('[data-lore-heading]');
      const copy = dialog.querySelector('[data-lore-copy]');
      if (title) title.textContent = lore.dataset.loreTitle || '';
      if (copy) copy.textContent = lore.dataset.loreText || '';
      let discoveries = [];
      try { discoveries = JSON.parse(localStorage.getItem('naticups-discoveries') || '[]'); if (!Array.isArray(discoveries)) discoveries = []; } catch {}
      if (!discoveries.includes(lore.dataset.lore)) discoveries.push(lore.dataset.lore);
      try { localStorage.setItem('naticups-discoveries', JSON.stringify(discoveries)); } catch {}
      document.querySelectorAll('[data-quest-count]').forEach(node => { node.textContent = String(discoveries.length); });
      openDialog(dialog, lore);
      return;
    }
    const menuButton = event.target.closest('[data-mobile-menu]');
    if (menuButton) {
      const menu = document.getElementById(menuButton.getAttribute('aria-controls'));
      if (menu) { const expanded = menuButton.getAttribute('aria-expanded') === 'true'; menuButton.setAttribute('aria-expanded', String(!expanded)); menu.hidden = expanded; }
    }
  });
  function initialize() {
    document.querySelectorAll('[data-product-section]').forEach(section => updateProduct(section));
    document.querySelectorAll('dialog').forEach(dialog => {
      if (dialog.dataset.commerceBound) return;
      dialog.dataset.commerceBound = 'true';
      dialog.addEventListener('close', () => { if (returnFocus?.isConnected) returnFocus.focus(); returnFocus = null; });
      dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); } });
    });
    try { const discoveries = JSON.parse(localStorage.getItem('naticups-discoveries') || '[]'); document.querySelectorAll('[data-quest-count]').forEach(node => { node.textContent = String(Array.isArray(discoveries) ? discoveries.length : 0); }); } catch {}
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
